import { render } from "./SummaryItem.vue?vue&type=template&id=329e725a&scoped=true"
import script from "./SummaryItem.vue?vue&type=script&lang=js"
export * from "./SummaryItem.vue?vue&type=script&lang=js"

import "./SummaryItem.vue?vue&type=style&index=0&id=329e725a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-329e725a"

export default script